export default { sha: 'cffe9a6339c557a330ed6dea1b29be40993e7f3d', buildNumber: 'undefined' }
